import { EStickyButtonActionTypes } from '../../actions/stickyButton';
import { TReduxActions } from '../../types/redux';

const defaultState = false;

export function stickyButtonReducer(state: boolean = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EStickyButtonActionTypes.Hide:
      return false;
    case EStickyButtonActionTypes.Show:
      return true;
    default:
      return state;
  }
}
